import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const PrimaryCircularProgress = withStyles((theme) => ({
  root: {
    '& .MuiCircularProgress-svg': {
      color: theme.palette.primary.main,
    },
    '& .MuiCircularProgress-circle': {
      stroke: theme.palette.primary.main,
    },
  },
}))(CircularProgress);
